  import React from "react";
// import Sidebar from "../../../components/sidebar/Sidebar";
import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar";
import Datatable from "./List/ClosedCamp.jsx";
// import Datatable from "./List/PausedCamp.jsx";
import "../../../components/common/css/index.scss";

const List = () => {
  return (
    <div className="list">
      <Sidebar/>
      <div className="listContainer">
        <Navbar/>
        <Datatable/>
      </div>
    </div>
  )
}

export default List